/**
 * Inline hyperlink to the parent brand TopSchool.
 * Used wherever "TopSchool" appears in body copy or chrome.
 */
const TopSchoolLink = ({ children = "TopSchool", className = "" }) => (
    <a
        href="https://topschool.ai"
        target="_blank"
        rel="noopener noreferrer"
        className={`underline decoration-brand-coral/40 hover:decoration-brand-coral underline-offset-[3px] hover:text-brand-coral transition-colors ${className}`}
    >
        {children}
    </a>
);

export default TopSchoolLink;
